import { useStorage } from '@vueuse/core'

import { useStore } from '~/store/useStore'

export function useSidebarSettings({ defaultExpandedLists }: { defaultExpandedLists: string[] }) {
  const { state } = useStore()
  const expandedLists = useStorage(
    `${state.user?.id ?? 'unknown'}-sidebar_expanded_lists`,
    defaultExpandedLists
  )

  return {
    isListExpanded(id: string) {
      return expandedLists.value.includes(id)
    },
    toggleList(id: string) {
      if (this.isListExpanded(id)) {
        expandedLists.value = expandedLists.value.filter((item) => item !== id)
      } else {
        expandedLists.value.push(id)
      }
    },
  }
}
